import _extends from "@babel/runtime-corejs3/helpers/extends";

var _ADJUSTMENT_MAP, _POINTER_ROTATION;

import _includesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/includes";
import _Number$isNaN from "@babel/runtime-corejs3/core-js-stable/number/is-nan";
import _indexOfInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/index-of";
import _everyInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/every";
import { positions } from "../../../enums"; // Model that describes the calculation of the next position of the tooltip

var ADJUSTMENT_MAP = (_ADJUSTMENT_MAP = {}, _ADJUSTMENT_MAP[positions.TOP] = {
  x: positions.TOP_LEFT,
  y: positions.BOTTOM
}, _ADJUSTMENT_MAP[positions.TOP_LEFT] = {
  x: positions.TOP_RIGHT,
  y: positions.BOTTOM
}, _ADJUSTMENT_MAP[positions.TOP_RIGHT] = {
  x: positions.RIGHT,
  y: positions.BOTTOM
}, _ADJUSTMENT_MAP[positions.RIGHT] = {
  x: positions.TOP,
  y: positions.BOTTOM
}, _ADJUSTMENT_MAP[positions.BOTTOM] = {
  x: positions.BOTTOM_LEFT,
  y: positions.TOP
}, _ADJUSTMENT_MAP[positions.BOTTOM_LEFT] = {
  x: positions.BOTTOM_RIGHT,
  y: positions.TOP
}, _ADJUSTMENT_MAP[positions.BOTTOM_RIGHT] = {
  x: positions.LEFT,
  y: positions.BOTTOM
}, _ADJUSTMENT_MAP[positions.LEFT] = {
  x: positions.RIGHT,
  y: positions.BOTTOM
}, _ADJUSTMENT_MAP); // Model that describes the calculation of pointer rotation

export var POINTER_ROTATION = (_POINTER_ROTATION = {}, _POINTER_ROTATION[positions.TOP] = 0, _POINTER_ROTATION[positions.TOP_LEFT] = 0, _POINTER_ROTATION[positions.TOP_RIGHT] = 0, _POINTER_ROTATION[positions.RIGHT] = 90, _POINTER_ROTATION[positions.BOTTOM] = 180, _POINTER_ROTATION[positions.BOTTOM_LEFT] = 180, _POINTER_ROTATION[positions.BOTTOM_RIGHT] = 180, _POINTER_ROTATION[positions.LEFT] = 270, _POINTER_ROTATION); //we need to slightly adjust the pixel position of the pointer based on the pointer square box with and height so that we can pixel-perfect position it or use the size of in the calculation in _tooltipAndPointerByCoordinates

var POINTER_INDENT = 6;
/**
 * Looks at the tooltip placement on the current DOM. If the tooltip is within screen bounds for the X and Y axis (which means the tooltip should be FULLY visible on the screen for the user) then it will return an enum string position from which we later build coordinates, OR it returns NULL when no adjustments are needed for the current position
 * @param {number} width - tooltip width
 * @param {number} height - tooltip height
 * @param {number} indentTop - top indent
 * @param {number} indentLeft - left indent
 * @param {string} position - an enum string value of a direction that the tooltip should be positioned at; used to calculate the X-Y coordinates
 * @param {object} boundaryRect - DOMRect from boundary element
 * @param {object} tooltipRect - DOMRect from tooltip
 * @param {object} exhausted - specifies whether x-axis or y-axis is already exhausted to switch between axis
 * @returns {string}  - returns new position string enum position or null for when the tooltip is correctly visible on the screen
 */

var _getAdjustedTooltipPosition = function _getAdjustedTooltipPosition(_ref) {
  var width = _ref.width,
      height = _ref.height,
      indentTop = _ref.indentTop,
      indentLeft = _ref.indentLeft,
      position = _ref.position,
      boundaryRect = _ref.boundaryRect,
      tooltipRect = _ref.tooltipRect,
      exhausted = _ref.exhausted;
  var vertical = exhausted.vertical,
      horizontal = exhausted.horizontal;
  var topBoundary = boundaryRect.top;
  var leftBoundary = boundaryRect.left;
  var rightBoundary = boundaryRect.right;
  var bottomBoundary = boundaryRect.bottom; // if the vertical alignment(Y-axis) of the tooltip is outside the visible screen then try to adjust the Y coordinate for the tooltip

  if (tooltipRect.top < topBoundary || indentTop + height > bottomBoundary) {
    return vertical ? ADJUSTMENT_MAP[position].x : ADJUSTMENT_MAP[position].y;
  } // if the horizontal alignment(X-axis) of the tooltip is outside the visible screen then try to adjust the X coordinate for the tooltip


  if (tooltipRect.left < leftBoundary || indentLeft + width > rightBoundary) {
    return horizontal ? ADJUSTMENT_MAP[position].y : ADJUSTMENT_MAP[position].x;
  } //else we do not need to adjust the position and we can simply return the original position letting the app know we have reached success


  return position;
};
/**
 * Returns value indicating if passed position is from vertical axis
 * @param {string} position - position value to check
 * @returns {boolean} - result of the check
 */


var _isVertical = function _isVertical(position) {
  var _context;

  return _includesInstanceProperty(_context = [positions.TOP, positions.TOP_LEFT, positions.TOP_RIGHT, positions.BOTTOM, positions.BOTTOM_LEFT, positions.BOTTOM_RIGHT]).call(_context, position);
};
/**
 * Looks at the pointer placement on the current DOM, adjusting it based on child element position.
 * @param {childLeft} childrenBounding - DOMRect from children element
 * @param {childWidth} childrenBounding - DOMRect from children element
 * @param {childTop} childrenBounding - DOMRect from children element
 * @param {childHeight} childrenBounding - DOMRect from children element
 * @param {tooltipWidth} tooltipBounding - DOMRect from tooltip
 * @param {tooltipHeight} tooltipBounding - DOMRect from tooltip
 * @param {tooltipLeft} tooltipBounding - DOMRect from tooltip
 * @param {tooltipTop} tooltipBounding - DOMRect from tooltip
 * @param {string} position - an enum string value of a direction that the tooltip should be positioned at
 * @param {object} coordinates - calculated coordinates based on position
 * @returns {object} - {
 *  left: number, - the left css property value for the tooltip
 *  top: number, - the top css property value for the tooltip
 * }
 */


var _getNudgedPointerPosition = function _getNudgedPointerPosition(_ref2) {
  var childLeft = _ref2.childLeft,
      childWidth = _ref2.childWidth,
      childTop = _ref2.childTop,
      childHeight = _ref2.childHeight,
      tooltipWidth = _ref2.tooltipWidth,
      tooltipHeight = _ref2.tooltipHeight,
      tooltipLeft = _ref2.tooltipLeft,
      tooltipTop = _ref2.tooltipTop,
      position = _ref2.position,
      coordinates = _ref2.coordinates;
  var arrowWidth = POINTER_INDENT * 2;
  var top = childTop - tooltipTop + childHeight / 2 - arrowWidth / 2;
  var left = childLeft - tooltipLeft + childWidth / 2 - arrowWidth / 2;
  var lowerBound = POINTER_INDENT;
  var leftUpperBound = tooltipWidth - POINTER_INDENT;
  var topUpperBound = tooltipHeight - POINTER_INDENT;
  left = left < lowerBound ? lowerBound : left;
  left = left + arrowWidth > leftUpperBound ? leftUpperBound - arrowWidth : left;
  top = top < lowerBound ? lowerBound : top;
  top = top + arrowWidth > topUpperBound ? topUpperBound - arrowWidth : top;

  if (_isVertical(position)) {
    return {
      top: coordinates.pointerY,
      left: _Number$isNaN(left) ? 0 : left
    };
  } else {
    return {
      top: _Number$isNaN(top) ? 0 : top,
      left: coordinates.pointerX
    };
  }
};
/**
 * Returns a complex object of coordinates based on the [position] value set by the user, relative to the child component that the tooltip wraps around.That value is represented by  the top and left css values for positioning the tooltip box and the top and left css values for the tooltips arrow pointer.
 * @param {string} position - an enum string value of a direction that the tooltip should be positioned at; used to calculate the X-Y coordinates
 * @param {childLeft} childrenBounding - DOMRect from children element
 * @param {childBottom} childrenBounding - DOMRect from children element
 * @param {childTop} childrenBounding - DOMRect from children element
 * @param {childWidth} childrenBounding - DOMRect from children element
 * @param {childHeight} childrenBounding - DOMRect from children element
 * @param {tooltipWidth} tooltipBounding - DOMRect from tooltip
 * @param {tooltipHeight} tooltipBounding - DOMRect from tooltip
 * @param {number} targetOffset - offset from child tooltip target to tooltip
 * @returns {object} - {
 *  left: number, - the left css property value for the tooltip
 *  top: number, - the top css property value for the tooltip
 *  pointerX: number, - the left css property value for the pointer of the tooltip
 *  pointerY: number, - the top css property value for the pointer of the tooltip
 * }
 */


var _tooltipAndPointerByCoordinates = function _tooltipAndPointerByCoordinates(_ref3) {
  var position = _ref3.position,
      childLeft = _ref3.childLeft,
      childBottom = _ref3.childBottom,
      childTop = _ref3.childTop,
      childWidth = _ref3.childWidth,
      childHeight = _ref3.childHeight,
      tooltipWidth = _ref3.tooltipWidth,
      tooltipHeight = _ref3.tooltipHeight,
      targetOffset = _ref3.targetOffset;

  switch (position) {
    case positions.BOTTOM:
      return {
        left: childLeft + childWidth / 2 - tooltipWidth / 2,
        top: childBottom + targetOffset + POINTER_INDENT,
        pointerX: tooltipWidth / 2 - POINTER_INDENT,
        pointerY: -POINTER_INDENT
      };

    case positions.BOTTOM_RIGHT:
      return {
        left: childLeft,
        top: childBottom + targetOffset + POINTER_INDENT,
        pointerX: POINTER_INDENT,
        pointerY: -POINTER_INDENT
      };

    case positions.BOTTOM_LEFT:
      return {
        left: childLeft + childWidth - tooltipWidth,
        top: childBottom + targetOffset + POINTER_INDENT,
        pointerX: tooltipWidth - POINTER_INDENT * 3,
        pointerY: -POINTER_INDENT
      };

    case positions.TOP:
      return {
        left: childLeft + childWidth / 2 - tooltipWidth / 2,
        top: childTop - tooltipHeight - POINTER_INDENT - targetOffset,
        pointerX: tooltipWidth / 2 - POINTER_INDENT,
        pointerY: tooltipHeight
      };

    case positions.TOP_RIGHT:
      return {
        left: childLeft,
        top: childTop - tooltipHeight - POINTER_INDENT - targetOffset,
        pointerX: POINTER_INDENT,
        pointerY: tooltipHeight
      };

    case positions.TOP_LEFT:
      return {
        left: childLeft + childWidth - tooltipWidth,
        top: childTop - tooltipHeight - POINTER_INDENT - targetOffset,
        pointerX: tooltipWidth - POINTER_INDENT * 3,
        pointerY: tooltipHeight
      };

    case positions.LEFT:
      return {
        left: childLeft - targetOffset - tooltipWidth - POINTER_INDENT,
        top: childTop + childHeight / 2 - tooltipHeight / 2,
        pointerX: tooltipWidth - POINTER_INDENT / 2,
        pointerY: tooltipHeight / 2 - POINTER_INDENT / 2
      };

    case positions.RIGHT:
      return {
        left: childLeft + targetOffset + childWidth + POINTER_INDENT,
        top: childTop + childHeight / 2 - tooltipHeight / 2,
        pointerX: -(POINTER_INDENT + POINTER_INDENT / 2),
        pointerY: tooltipHeight / 2 - POINTER_INDENT / 2
      };
  }
};
/**
 * Returns element rectangle properties, based on top, left coordinates and width, height of the element.
 * @param {top} tooltipBounding - DOMRect from tooltip
 * @param {left} tooltipBounding - DOMRect from tooltip
 * @param {width} tooltipBounding - DOMRect from tooltip
 * @param {height} tooltipBounding - DOMRect from tooltip
 * @returns {object} - {
 * left: number, - the left property value for the element
 * top: number, - the top property value for the element
 * bottom: number, - the bottom property value for the element
 * right: number, - the right property value for the element
 * width: number, - the width value for the element
 * height: number, - the height value for the element
 */


var _createRect = function _createRect(_ref4) {
  var top = _ref4.top,
      left = _ref4.left,
      width = _ref4.width,
      height = _ref4.height;
  return {
    top: top,
    left: left,
    width: width,
    height: height,
    right: left + width,
    bottom: top + height
  };
};
/** Returns result of comparison of two rectangles positions
 * @param {object} initialRect - DOMRect
 * @param {object} rect - DOMRect
 * @returns {boolean} - whether rectangles positions are same
 */


export var matchesPosition = function matchesPosition(initialRect, rect) {
  return initialRect === rect || Math.round(initialRect.left) === Math.round(rect.left) && Math.round(initialRect.top) === Math.round(rect.top);
};
/**
 * Returns element rectangle properties, based on boundary rectangle and tooltip rectangle, to fit tooltip considering boundary limits
 * @param {object} tooltipRect - DOMRect from tooltip
 * @param {object} boundaryRect - DOMRect from boundary element
 * @returns {object} - {
 *  left: number, - the left property value for the element
 *  top: number, - the top property value for the element
 *  bottom: number, - the bottom property value for the element
 *  right: number, - the right property value for the element
 *  width: number, - the width value for the element
 *  height: number, - the height value for the element
 * }
 */

var _getNudgedTooltipRect = function _getNudgedTooltipRect(tooltipRect, boundaryRect) {
  var topBoundary = boundaryRect.top;
  var leftBoundary = boundaryRect.left;
  var rightBoundary = boundaryRect.right;
  var bottomBoundary = boundaryRect.bottom;
  var top = tooltipRect.top < topBoundary ? topBoundary : tooltipRect.top;
  top = top + tooltipRect.height > bottomBoundary ? bottomBoundary - tooltipRect.height : top;
  var left = tooltipRect.left < leftBoundary ? leftBoundary : tooltipRect.left;
  left = left + tooltipRect.width > rightBoundary ? rightBoundary - tooltipRect.width : left;
  return _createRect(_extends({}, tooltipRect, {
    top: top,
    left: left
  }));
};
/**
 * Returns boundary element rectangle properties, accounting scrolled part of the document if any, to consider only visible area.
 * @param {object} boundaryElement - DOM element
 * @returns {object} - {
 *  scrolledRect - DOMRect considering scrolled position
 *  scrolled - boolean value indicating whether page was scrolled
 * }
 */


var getBoundaryRect = function getBoundaryRect(boundaryElement) {
  var boundaryRect = boundaryElement.getBoundingClientRect();
  var x = -boundaryElement.scrollLeft;
  var y = -boundaryElement.scrollTop;
  var width = Math.max(boundaryElement.scrollWidth, boundaryElement.clientWidth);
  var height = Math.max(boundaryElement.scrollHeight, boundaryElement.clientHeight);
  var scrolled = window.pageYOffset >= Math.abs(boundaryRect.top) || window.pageXOffset >= Math.abs(boundaryRect.left);
  var left = window.pageXOffset > Math.abs(boundaryRect.left) ? boundaryRect.left : x;
  var top = window.pageYOffset > Math.abs(boundaryRect.top) ? boundaryRect.top : y;
  var scrolledRect = scrolled ? _extends({}, boundaryRect, {
    x: left,
    y: top,
    left: left,
    top: top,
    right: boundaryRect.right,
    bottom: boundaryRect.bottom,
    width: width,
    height: height
  }) : boundaryRect;
  return {
    scrolled: scrolled,
    scrolledRect: scrolledRect
  };
};
/**
 * Returns boolean value, specifying whether tooltip rectangle at current position will violate boundaries.
 * @param {object} boundaryRect - DOMRect from boundary element
 * @param {object} rect - DOMRect from tooltip
 * @returns {boolean} - whether tooltip rectangle at current position violates boundaries
 */


var hasBoundaryViolation = function hasBoundaryViolation(_ref5) {
  var boundaryRect = _ref5.boundaryRect,
      rect = _ref5.rect;
  var topBoundary = boundaryRect.top;
  var leftBoundary = boundaryRect.left;
  var rightBoundary = boundaryRect.right;
  var bottomBoundary = boundaryRect.bottom;
  var hasViolations = rect.top < topBoundary || rect.top < 0 || rect.left < leftBoundary || rect.left < 0 || rect.right > rightBoundary || rect.right < 0 || rect.bottom > bottomBoundary || rect.bottom < 0;
  return hasViolations;
};
/**
 * Constructs current tooltip state based on position provided
 * @param {string} position - current position
 * @param {object} childrenBounding - DOMRect from children element
 * @param {object} tooltipBounding - DOMRect from tooltip
 * @param {number} targetOffset - offset from child tooltip target to tooltip
 * @returns {object} - returns object { coordinates - tooltip and pointer coordinates, rect - DOMRect of tooltip }
 */


var getTooltipStateByPosition = function getTooltipStateByPosition(_ref6) {
  var position = _ref6.position,
      childrenBounding = _ref6.childrenBounding,
      tooltipBounding = _ref6.tooltipBounding,
      targetOffset = _ref6.targetOffset;
  var tooltipWidth = tooltipBounding.width,
      tooltipHeight = tooltipBounding.height;
  var childWidth = childrenBounding.width,
      childHeight = childrenBounding.height,
      childLeft = childrenBounding.left,
      childTop = childrenBounding.top,
      childBottom = childrenBounding.bottom;

  var coordinates = _tooltipAndPointerByCoordinates({
    position: position,
    childLeft: childLeft,
    childBottom: childBottom,
    childWidth: childWidth,
    childTop: childTop,
    childHeight: childHeight,
    tooltipWidth: tooltipWidth,
    tooltipHeight: tooltipHeight,
    targetOffset: targetOffset
  });

  var rect = _createRect(_extends({}, coordinates, {
    width: tooltipWidth,
    height: tooltipHeight
  }));

  return {
    coordinates: coordinates,
    rect: rect
  };
};
/**
 * Calculate tooltip coordinates in window
 * @param {string} position - current position
 * @param {string} prevPosition - previously set tooltip position
 * @param {object} childrenBounding - DOMRect from children element
 * @param {object} tooltipBounding - DOMRect from tooltip
 * @param {object} boundaryElement - DOM element
 * @param {number} targetOffset - offset from child tooltip target to tooltip
 * @param {boolean} floatingPointer - is floating pointer behaviour is desired
 * @returns {object} - returns object { x: number, y: number, pointerX: number, pointerY: number, position: string }
 */


export var getTooltipCoordinates = function getTooltipCoordinates(_ref7) {
  var position = _ref7.position,
      prevPosition = _ref7.prevPosition,
      childrenBounding = _ref7.childrenBounding,
      tooltipBounding = _ref7.tooltipBounding,
      boundaryElement = _ref7.boundaryElement,
      targetOffset = _ref7.targetOffset,
      floatingPointer = _ref7.floatingPointer;
  var tooltipWidth = tooltipBounding.width,
      tooltipHeight = tooltipBounding.height,
      tooltipLeft = tooltipBounding.left,
      tooltipTop = tooltipBounding.top;
  var childWidth = childrenBounding.width,
      childHeight = childrenBounding.height,
      childLeft = childrenBounding.left,
      childTop = childrenBounding.top,
      childBottom = childrenBounding.bottom; //We now try to do a cycle of attempts where we adjust the tooltip on the screen until it ends up visible. We can end up with one or more attempts until we hit a success.

  var adjustedPosition = position;
  var coordinates;
  var positionAttempts = []; //we need to store the position we attempt to render the tooltip as we loop through all possible positions; this is to break through an infinite loop potential if there are no possible positions to place it in

  var rect = null;
  var exhausted = {
    vertical: false,
    horizontal: false
  };
  var boundaryViolation = true;

  var _getBoundaryRect = getBoundaryRect(boundaryElement),
      boundaryRect = _getBoundaryRect.scrolledRect,
      scrolled = _getBoundaryRect.scrolled;

  var containsChild = boundaryRect.left < childLeft && boundaryRect.top < childTop && boundaryRect.right > childLeft - childWidth && boundaryRect.bottom > childBottom - childHeight;

  do {
    var _context2, _context3;

    positionAttempts.push(adjustedPosition); //grab the coordinates needed for the tooltip and its pointer

    coordinates = _tooltipAndPointerByCoordinates({
      position: adjustedPosition,
      childLeft: childLeft,
      childBottom: childBottom,
      childWidth: childWidth,
      childTop: childTop,
      childHeight: childHeight,
      tooltipWidth: tooltipWidth,
      tooltipHeight: tooltipHeight,
      targetOffset: targetOffset
    });
    /*
    Once we have the coordinates we then try to see if we require an adjustment of the position of the tooltip.
     On the first iteration this is generally required as the position is not properly set.
     On consecutive adjustments we use ADJUSTMENT_MAP to bounce around the element until we find a proper position where we can place the tooltip. This position can be different than the one the user has specify, if the original position cannot visibly display the tooltip.
    */

    rect = _createRect(_extends({}, coordinates, {
      width: tooltipWidth,
      height: tooltipHeight
    }));

    var isVertical = _isVertical(adjustedPosition); //resetting axis if direction was switcched


    exhausted = {
      horizontal: !isVertical && _everyInstanceProperty(_context2 = [positions.LEFT, positions.RIGHT]).call(_context2, function (position) {
        return _includesInstanceProperty(positionAttempts).call(positionAttempts, position);
      }),
      vertical: isVertical && _everyInstanceProperty(_context3 = [positions.TOP, positions.BOTTOM]).call(_context3, function (position) {
        return _includesInstanceProperty(positionAttempts).call(positionAttempts, position);
      })
    };

    var newPosition = _getAdjustedTooltipPosition({
      width: tooltipWidth,
      height: tooltipHeight,
      indentTop: coordinates.top,
      indentLeft: coordinates.left,
      childLeft: childLeft,
      childTop: childTop,
      position: adjustedPosition,
      boundaryRect: boundaryRect,
      tooltipRect: coordinates,
      exhausted: exhausted
    });

    boundaryViolation = hasBoundaryViolation({
      boundaryRect: boundaryRect,
      rect: rect
    }); //we need to prevent setting up a new position if it has been an attempt in the past for it,
    //and proceeding in case one of axises exhausted or child is outside of boundaries

    if (_indexOfInstanceProperty(positionAttempts).call(positionAttempts, newPosition) === -1 || exhausted.horizontal && exhausted.vertical || !containsChild) {
      adjustedPosition = newPosition;
    } //keep looping as long as we continue to adjust the position
    //break loop if we are attempting to use the same position again, this means we did not have to adjust the original position or we simply failed to find a suitable position to render it at

  } while (_indexOfInstanceProperty(positionAttempts).call(positionAttempts, adjustedPosition) === -1 && boundaryViolation); // in case user drags or zooms elements on the page, tooltip child can be shifted out of boundaries, so previous position will be preserved if any other doesn't fit


  if (!containsChild && boundaryViolation) {
    var tooltipState = getTooltipStateByPosition({
      position: prevPosition,
      childrenBounding: childrenBounding,
      tooltipBounding: tooltipBounding,
      targetOffset: targetOffset
    });
    adjustedPosition = prevPosition;
    coordinates = tooltipState.coordinates;
    rect = tooltipState.rect;
  } // in case tooltip stays open (triggered by "click") while user scrolls the page, we need to preserve tooltip previous position if any other doesn't fit


  if (scrolled) {
    boundaryRect = boundaryElement.getBoundingClientRect();
    boundaryViolation = hasBoundaryViolation({
      boundaryRect: boundaryRect,
      rect: rect
    });

    if (boundaryViolation) {
      var _tooltipState = getTooltipStateByPosition({
        position: prevPosition,
        childrenBounding: childrenBounding,
        tooltipBounding: tooltipBounding,
        targetOffset: targetOffset
      });

      adjustedPosition = prevPosition;
      coordinates = _tooltipState.coordinates;
      rect = _tooltipState.rect;
    }
  } // considering position against tooltip target, sanitize tooltip final position to boundaries limits


  var _getNudgedTooltipRect2 = _getNudgedTooltipRect(rect, boundaryRect),
      nudgedLeft = _getNudgedTooltipRect2.left,
      nudgedTop = _getNudgedTooltipRect2.top;

  if (floatingPointer) {
    var _getNudgedPointerPosi = _getNudgedPointerPosition({
      childLeft: childLeft,
      childWidth: childWidth,
      childTop: childTop,
      childHeight: childHeight,
      tooltipWidth: tooltipWidth,
      tooltipHeight: tooltipHeight,
      tooltipLeft: nudgedLeft,
      tooltipTop: nudgedTop,
      position: adjustedPosition,
      coordinates: coordinates
    }),
        pointerX = _getNudgedPointerPosi.left,
        pointerY = _getNudgedPointerPosi.top;

    coordinates.pointerX = pointerX;
    coordinates.pointerY = pointerY;
  }

  coordinates.left = nudgedLeft;
  coordinates.top = nudgedTop;
  return _extends({}, coordinates, {
    position: adjustedPosition
  });
};
//# sourceMappingURL=utils.js.map